"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var localization_1 = require("../constants/localization");
exports.getAfterCallGuest = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".afterCallGuest") || localization_1.complianceLinks[localization_1.defaultLanguageId].afterCallGuest;
};
exports.getCookieCompliance = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".cookie") || localization_1.complianceLinks[localization_1.defaultLanguageId].cookie;
};
exports.getHelpPage = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".help") || localization_1.complianceLinks[localization_1.defaultLanguageId].help;
};
exports.getHelpPageGuest = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".helpGuest") || localization_1.complianceLinks[localization_1.defaultLanguageId].helpGuest;
};
exports.getLanguage = function (id) {
    return lodash_1.get(exports.getLanguageObj(id), 'language');
};
exports.getLanguageDisplayName = function (id) {
    return lodash_1.get(exports.getLanguageObj(id), 'displayName');
};
exports.getLanguageId = function (code, approvedLanguages) {
    if (code === void 0) { code = ''; }
    var lcCode = code.toLowerCase().replace('_', '-');
    var language = lcCode.split('-')[0];
    var languages = approvedLanguages || localization_1.supportedLanguages;
    var supportedLanguage = lodash_1.find(languages, function (languageObj) {
        return (languageObj.id.toLowerCase() === lcCode) || (languageObj.aliases && languageObj.aliases.includes(lcCode));
    });
    return lodash_1.get(supportedLanguage, 'id')
        || lodash_1.get(lodash_1.find(languages, ['language', language]), 'id')
        || localization_1.defaultLanguageId;
};
exports.getLanguageIdForPlatform = function (id, platform) {
    return lodash_1.get(exports.getLanguageObj(id), "platform['" + platform + "']") || id;
};
exports.getLanguageObj = function (id) {
    return lodash_1.find(localization_1.supportedLanguages, ['id', id]);
};
exports.getLanguageOptions = function () {
    return lodash_1.sortBy(localization_1.supportedLanguages.map(function (language) { return lodash_1.pick(language, ['id', 'displayName']); }), ['displayName']);
};
exports.getLegacyLanguageId = function (id) {
    if (id === void 0) { id = ''; }
    var language = id.split('-')[0] || exports.getLanguage(localization_1.defaultLanguageId) || localization_1.defaultLanguageId.split('-')[0];
    return (language === 'zh') ? id : language;
};
exports.getPrivacyPolicy = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".privacy") || localization_1.complianceLinks[localization_1.defaultLanguageId].privacy;
};
exports.getTermsOfService = function (id) {
    return lodash_1.get(localization_1.complianceLinks, id + ".tos") || localization_1.complianceLinks[localization_1.defaultLanguageId].tos;
};
exports.default = {
    getAfterCallGuest: exports.getAfterCallGuest,
    getCookieCompliance: exports.getCookieCompliance,
    getHelpPage: exports.getHelpPage,
    getHelpPageGuest: exports.getHelpPageGuest,
    getLanguage: exports.getLanguage,
    getLanguageDisplayName: exports.getLanguageDisplayName,
    getLanguageId: exports.getLanguageId,
    getLanguageIdForPlatform: exports.getLanguageIdForPlatform,
    getLanguageObj: exports.getLanguageObj,
    getLanguageOptions: exports.getLanguageOptions,
    getLegacyLanguageId: exports.getLegacyLanguageId,
    getPrivacyPolicy: exports.getPrivacyPolicy,
    getTermsOfService: exports.getTermsOfService
};
//# sourceMappingURL=localization.js.map